document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-shop-the-look]').forEach(function (section) {
    var media = section.querySelector('.shop-the-look__media');
    var openPopup = null;

    function closeAll() {
      section.querySelectorAll('[data-hotspot-popup]').forEach(function (p) {
        p.hidden = true;
        p.style.transform = '';
        p.classList.remove('is-below');
      });
      section.querySelectorAll('[data-hotspot-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      openPopup = null;
    }

    function positionPopup(popup) {
      var mediaRect = media.getBoundingClientRect();
      var rect = popup.getBoundingClientRect();

      if (rect.top < 10) {
        popup.classList.add('is-below');
        rect = popup.getBoundingClientRect();
      }

      var overflowRight = rect.right - mediaRect.right;
      var overflowLeft = mediaRect.left - rect.left;
      if (overflowRight > 0) {
        popup.style.transform = 'translateX(calc(-50% - ' + (overflowRight + 8) + 'px))';
      } else if (overflowLeft > 0) {
        popup.style.transform = 'translateX(calc(-50% + ' + (overflowLeft + 8) + 'px))';
      }
    }

    section.querySelectorAll('[data-hotspot-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var wrapper = btn.closest('.shop-the-look__point');
        var popup = wrapper.querySelector('[data-hotspot-popup]');
        var wasOpen = !popup.hidden;
        closeAll();
        if (!wasOpen) {
          popup.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
          openPopup = popup;
          positionPopup(popup);
        }
      });
    });

    section.querySelectorAll('[data-hotspot-close]').forEach(function (btn) {
      btn.addEventListener('click', closeAll);
    });

    document.addEventListener('click', function (e) {
      if (openPopup && !e.target.closest('.shop-the-look__point')) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openPopup) closeAll();
    });
  });
});
